import { Injectable } from '@angular/core';
import { StudentInternshipModel } from 'common/models/page-models/student-side/internship/student-internship-data.model';
import { studentInternshipGridMetaModel } from 'common/models/page-models/student-side/internship/student-internship-grid-meta.model';
import { StudentInternshipListingModel } from 'common/models/page-models/student-side/internship/student-internship-grid-model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentInternshipDataService } from 'common/services/data-services/student/student-internship/student-internship.service';
import { GridWidgetService } from 'common/widget/grid-widget.services';

@Injectable({
  providedIn: 'root'
})
export class StudentInternshipWidgetService extends GridWidgetService<
StudentInternshipModel,
StudentInternshipListingModel
> {

  constructor(
    protected override ds: StudentInternshipDataService,
    protected systemService: SystemService,
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new studentInternshipGridMetaModel().getMetaModel();
    return meta;
  }

}
